var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.text)+"《"),_c('span',[_vm._v(_vm._s(_vm.info.name))]),_vm._v("》")])])}
var staticRenderFns = []

export { render, staticRenderFns }